import { WrCustomerBadgeController as controller } from './wr-customer-badge.controller'
import template from './wr-customer-badge.html'

/**
 * WrCustomerBadge Component
 *
 */
export const WrCustomerBadgeComponent = {
  bindings: {
    /**
     * @property {Customer} bindings.customer
     *           The Customer that the badge should represent.
     *
     * @property {Object} [bindings.customerBalances]
     *           The current balances for the customer.
     *
     * @property {Object} [bindings.viewOptions]
     *           @property {Object} [bindings.viewOptions.canViewDetails = true]
     *                     Determines if the view customer modal can be shown.
     *
     *           @property {Object} [bindings.viewOptions.hideRemoveFromSale = false]
     *                     Determines if the remove customer from sale icon is visible. Also controls the
     *                     visibility of the "remove from sale" button within the view customer modal.
     *
     *           @property {Object} [bindings.viewOptions.hideViewSales = false]
     *                     Determines if the "view customer sales" button within the view customer modal should
     *                     be shown.
     *
     *           @property {Object} [bindings.viewOptions.canAddAccountBalancePayment = false]
     *                     Determines if the "add account balance payment" banner above the customer badge is shown.
     */
    customer: '<',
    customerBalances: '<?',
    viewOptions: '<?',
  },
  controller,
  template,
}
